export default function getTextColorForBackground(backgroundColor?: string) {
  if (!backgroundColor || !backgroundColor.startsWith("#")) return "#0F172A";
  const hex = backgroundColor.replace("#", "");
  const normalizedHex = hex.length === 3
    ? hex.split("").map((c) => c + c).join("")
    : hex;
  if (normalizedHex.length !== 6) return "#0F172A";

  const red = parseInt(normalizedHex.substring(0, 2), 16);
  const green = parseInt(normalizedHex.substring(2, 4), 16);
  const blue = parseInt(normalizedHex.substring(4, 6), 16);
  const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

  return brightness > 150 ? "#0F172A" : "#FFFFFF";
}
